function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import equals from "fast-deep-equal";
import { applyPatches, enablePatches, produce } from "immer";
import get from "lodash/get";
import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import set from "lodash/set";
import { useCallback, useRef, useState } from "react";
import { REGEX } from "../constants";
enablePatches();
var EMAIL_VALIDATOR_CONFIG = {
    type: 'pattern',
    pattern: REGEX.email,
    message: 'Must be a valid email'
};
var PHONE_VALIDATOR_CONFIG = {
    type: 'pattern',
    pattern: REGEX.phone,
    message: 'Must be a valid phone number'
};
export var VALIDATORS = {
    present: function(v, config) {
        var _config_message;
        return !!v || typeof v === 'number' ? undefined : (_config_message = config === null || config === void 0 ? void 0 : config.message) !== null && _config_message !== void 0 ? _config_message : 'Must be present';
    },
    length: function(v, config) {
        if (v) {
            if (typeof config.minimum === 'number' && typeof config.maximum === 'number' && config.minimum === config.maximum && v.toString().length !== config.maximum) {
                return "Must be exactly ".concat(config.minimum, " characters");
            }
            if (typeof config.minimum === 'number' && v.toString().length < config.minimum) {
                return "Must be at least ".concat(config.minimum, " characters");
            }
            if (typeof config.maximum === 'number' && v.toString().length > config.maximum) {
                return "Must be at most ".concat(config.maximum, " characters");
            }
        }
        return !!v ? undefined : 'Must be present';
    },
    pattern: function(v, config) {
        if (!v && config.allowBlank) return;
        if (!v) {
            return config.message;
        }
        if (typeof v === 'string') {
            var pattern = config.pattern;
            return v.match(pattern) ? undefined : config.message;
        }
    },
    email: function(v, config) {
        return VALIDATORS.pattern(v, _object_spread({}, config, EMAIL_VALIDATOR_CONFIG));
    },
    phone: function(v, config) {
        return VALIDATORS.pattern(v, _object_spread({}, config, PHONE_VALIDATOR_CONFIG));
    },
    number: function(v) {
        if (!v) {
            return 'Must be present';
        }
        var parsed = Number(v);
        if (!Number.isFinite(parsed)) {
            return 'Must be a number';
        }
        return;
    }
};
export function useForm(defaultData) {
    var formOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState = _sliced_to_array(useState({}), 2), data = _useState[0], setData = _useState[1];
    var undoState = useRef({
        index: -1,
        entries: []
    });
    var _useState1 = _sliced_to_array(useState({}), 2), errors = _useState1[0], setErrors = _useState1[1];
    var _useState2 = _sliced_to_array(useState({}), 2), humanValidationErrors = _useState2[0], setHumanValidationErrors = _useState2[1];
    var validators = useRef({});
    var formOptionsRef = useRef(formOptions);
    var merged = formOptions.merger ? mergeWith({}, defaultData || {}, data, formOptions.merger) : merge({}, defaultData || {}, data);
    var variablesRef = useRef(merged);
    if (!equals(merged, variablesRef.current)) {
        variablesRef.current = merged;
    }
    if (!equals(formOptions, formOptionsRef.current)) {
        formOptionsRef.current = formOptions;
    }
    function bind(nameOrNameFn, options) {
        var name = typeof nameOrNameFn === 'function' ? nameOrNameFn(merged) : nameOrNameFn;
        var pathKey = typeof name === 'string' ? name : name.join('.');
        if (options.validator) {
            var _options_arialabel;
            validators.current[pathKey] = {
                label: (_options_arialabel = options['aria-label']) !== null && _options_arialabel !== void 0 ? _options_arialabel : options.label,
                validator: options.validator
            };
        } else {
            delete validators.current[pathKey];
        }
        var _options_testID;
        var returnValue = {
            testID: (_options_testID = options.testID) !== null && _options_testID !== void 0 ? _options_testID : "INPUT_".concat(pathKey.replace(/\./g, '_')),
            error: get(errors, name),
            value: get(merged, name, options.defaultValue),
            onChangeValue: function(newVal) {
                setData(function(curr) {
                    return produce(curr, function(f) {
                        // typescript thinks set() may return a promise but I dont think it's actually possible
                        // to have a promise value in a form
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        set(f, name, newVal);
                    }, function(patches, inversePatches) {
                        var index = undoState.current.index += 1;
                        undoState.current.entries[index] = {
                            timestamp: Date.now(),
                            patches: patches,
                            inversePatches: inversePatches
                        };
                    });
                });
            }
        };
        if (options.label) {
            returnValue.label = options.label;
        }
        if (options['aria-label']) {
            returnValue['aria-label'] = options['aria-label'];
        }
        return returnValue;
    }
    // TODO implement undo/redo groups by leveraging timestamp to detect changes within x millis
    var canUndo = !(undoState.current.index < 0);
    function undo() {
        if (!canUndo) return;
        setData(function(curr) {
            var currentEntry = undoState.current.entries[undoState.current.index];
            undoState.current.index -= 1;
            return applyPatches(curr, _to_consumable_array(currentEntry.inversePatches).reverse());
        });
    }
    var canRedo = !(undoState.current.index < -1 || undoState.current.index === undoState.current.entries.length - 1);
    function redo() {
        if (!canRedo) return;
        setData(function(curr) {
            undoState.current.index += 1;
            var currentEntry = undoState.current.entries[undoState.current.index];
            return applyPatches(curr, currentEntry.patches);
        });
    }
    var validate = useCallback(function() {
        var validationErrors = {};
        var humanValidationErrs = {};
        Object.entries(validators.current).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), path = _param[0], entry = _param[1];
            if (!entry) return;
            var label = entry.label, validatorOrValidators = entry.validator;
            var validatorsArray = Array.isArray(validatorOrValidators) ? validatorOrValidators : [
                validatorOrValidators
            ];
            validatorsArray.map(function(validator) {
                var value = get(variablesRef.current, path);
                var error = typeof validator === 'function' ? validator(value) : VALIDATORS[validator.type](value, validator);
                // TODO instead of overwritting an existing error, turn into an array and/or join
                if (error) {
                    set(validationErrors, path, error);
                    if (label) {
                        set(humanValidationErrs, label, error);
                    }
                }
            });
        });
        if (formOptionsRef.current.validate) {
            validationErrors = formOptionsRef.current.validate(variablesRef.current, validationErrors);
        }
        setErrors({});
        setHumanValidationErrors({});
        setTimeout(function() {
            setErrors(validationErrors);
            setHumanValidationErrors(humanValidationErrs);
        }, 0);
        return Object.keys(validationErrors).length === 0;
    }, []);
    var dirty = !!Object.keys(data).length;
    var dirtyRef = useRef(dirty);
    dirtyRef.current = dirty;
    var clear = useCallback(function() {
        dirtyRef.current = false;
        setData({});
        setErrors({});
        setHumanValidationErrors({});
    }, []);
    return {
        dirty: dirty,
        dirtyRef: dirtyRef,
        bind: bind,
        clear: clear,
        data: variablesRef.current,
        redo: canRedo ? redo : undefined,
        undo: canUndo ? undo : undefined,
        validate: validate,
        errors: errors,
        humanErrors: humanValidationErrors,
        produceData: function(cb) {
            setData(produce(variablesRef.current, cb));
        }
    };
}
